import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChevronRight = function ChevronRight(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1113 12.2441C19.1113 11.7822 18.9502 11.4062 18.5742 11.0518L10.335 2.99512C10.0557 2.70508 9.71191 2.56543 9.29297 2.56543C8.46582 2.56543 7.78906 3.23145 7.78906 4.05859C7.78906 4.4668 7.96094 4.84277 8.26172 5.14355L15.5664 12.2334L8.26172 19.3447C7.96094 19.6348 7.78906 20.0107 7.78906 20.4297C7.78906 21.2568 8.46582 21.9229 9.29297 21.9229C9.70117 21.9229 10.0557 21.7832 10.335 21.4932L18.5742 13.4365C18.9502 13.082 19.1113 12.6953 19.1113 12.2441Z"
  })));
};

ChevronRight.displayName = 'ChevronRight';
export default ChevronRight;